import { useEffect, useState } from "react";
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
export default function MyTable({id, tbldata, columns,heading, pageSize = 15,isView=false,isEdit=false,isDelete=false,viewFunction,editFunction,deleteFunction}) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  // 🔽 Filter dropdown values per column
  const [filters, setFilters] = useState({});

  // 🔼 Sorting State
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  useEffect(() => {
    setData([...tbldata]);
  }, [tbldata]);

  // 🔎 Global Search + Column Filters
  const filteredData = data.filter(row =>
    columns.every(col => {
      const filterValue = filters[col.key];
      const matchFilter = !filterValue || row[col.key] == filterValue;      
      return matchFilter;
    })
  );

  // 🔽 Sorting Function
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const x = a[sortConfig.key]?.toString().toLowerCase();
    const y = b[sortConfig.key]?.toString().toLowerCase();
    return (x > y ? 1 : -1) * (sortConfig.direction === "asc" ? 1 : -1);
  });

  const handleSort = key => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  // Unique values for column filter dropdown (auto generated)
  const getUniqueValues = key => [...new Set(data.map(row => row[key]))];  
  
  return (
    <div>

      <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>{heading}</div>
      <div className="table-responsive" style={{fontSize:'12px'}}>
        <table id={id} className="table table-bordered table-striped">
          <thead>
            <tr>
                <th>S.No</th> {/* NEW SERIAL HEADER */}
                {columns.map(col => (
                    col.key !== "ID" && col.key !== "id" && (
                    <th 
                        key={col.key}
                        onClick={() => col.sortable && handleSort(col.key)} 
                        style={{ cursor: col.sortable ? "pointer" : "default" }}
                    >
                        {col.name}
                        {col.sortable && (
                        <span className="ms-1">
                            {sortConfig.key === col.key
                            ? (sortConfig.direction === "asc" ? "▲" : "▼")
                            : "↕"}
                        </span>
                        )}
                    </th>
                    )
                ))}
                {isView?(<th>View</th>):(<></>)}
                {isEdit?(<th>Edit</th>):(<></>)}
                {isDelete?(<th>Delete</th>):(<></>)}                
                </tr>
            {/* 🔽 Column Filter Dropdowns */}
            <tr>
              {columns.map(col => (
                <th key={col.key}>
                  {col.filterable && (
                    <select
                      className="form-select form-select-sm"
                      value={filters[col.key] || ""}
                      onChange={e => {
                        setFilters(prev => ({ ...prev, [col.key]: e.target.value || null }));
                        setPage(1);
                      }}
                    >
                      <option value="">All</option>
                      {getUniqueValues(col.key).map(val => (
                        <option key={val} value={val}>{val}</option>
                      ))}
                    </select>
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sortedData.slice((page - 1) * pageSize, page * pageSize).map((row, i) => (
                <tr key={row.ID || row.id || i}>  {/* Prefer ID if available */}
                  {/* 👇 SERIAL NUMBER COLUMN */}
                    <td>{(page - 1) * pageSize + (i + 1)}</td>
                    {/* 👇 DISPLAY ALL OTHER COLUMNS BUT SKIP ID */}
                    {columns.map(col => (
                        col.key !== "ID" && col.key !== "id" && (
                        <td key={col.key}>
                        {col.format ? col.format(row[col.key], row) : row[col.key]}
                        </td>                    
                    )                    
                ))}

                {isView?(<td className="text-center"><img data-bs-toggle="tooltip" onClick={()=>{viewFunction(row.id);}} title="View" src={viewIcon} style={{cursor:'pointer',width:'15px'}} /></td>):(<></>)}
                {isEdit?(<td className="text-center"><img data-bs-toggle="tooltip" onClick={()=>{editFunction(row.id);}} title="Edit"  src={editIcon} style={{cursor:'pointer',width:'15px'}} /></td>):(<></>)}
                {isDelete?(<td className="text-center"><img data-bs-toggle="tooltip" onClick={()=>{deleteFunction(row.id);}} title="Delete" src={deleteIcon} style={{cursor:'pointer',width:'15px'}} /></td>):(<></>)}                
            </tr>
            ))}

          </tbody>
        </table>
      </div>

      {/* ⏮ Pagination */}
      <div className="d-flex justify-content-between mt-2">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="btn btn-sm btn-primary"
        >Prev</button>

        <span>
          Page {page} / {Math.ceil(sortedData.length / pageSize)}
        </span>

        <button
          disabled={page * pageSize >= sortedData.length}
          onClick={() => setPage(page + 1)}
          className="btn btn-sm btn-primary"
        >Next</button>
      </div>
    </div>
  );
}
